module.exports = __webpack_public_path__ + "5c3b34060568f51b23e83bb0a16b964a.png";